/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Metadata_Add_DescInputs */



/**
* | output |
* | --- |
* | "Add metadata information that will be included with your project exports" |
*
* @param {Options_Metadata_Add_DescInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_metadata_add_desc = /** @type {((inputs?: Options_Metadata_Add_DescInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Metadata_Add_DescInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ajouter des métadonnées qui seront incluses dans les exportations du projet")
	if (locale === "de") return /** @type {LocalizedString} */ ("Fügen Sie Metadateninformationen hinzu, die in Ihre Projektexporte einbezogen werden sollen.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Aggiungi informazioni sui metadati che saranno incluse nelle esportazioni del tuo progetto")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Добавьте метаданные, которые будут включены в экспорт вашего проекта.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Agregue información de metadatos que se incluirá con las exportaciones de su proyecto")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("添加将包含在项目导出文件中的元数据信息")
	if (locale === "ja") return /** @type {LocalizedString} */ ("プロジェクトのエクスポートに含まれるメタデータ情報を追加します")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अपने प्रोजेक्ट एक्सपोर्ट के साथ शामिल की जाने वाली मेटाडेटा जानकारी जोड़ें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Adicione informações de metadados que serão incluídas nas exportações do seu projeto.")
	return /** @type {LocalizedString} */ ("Add metadata information that will be included with your project exports")
});